import React, { useState, Fragment, useEffect, useRef, useMemo } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

import AscendingSvg from '../../components/Form/SortSvg/AscendingSvg';
import DescendingSvg from '../../components/Form/SortSvg/DescendingSvg';

import ActiveVacancyLists from '../../components/List/Vacancy/ActiveVacancyLists';
import ModerationVacancyLists from '../../components/List/Vacancy/ModerationVacancyLists';
import InActiveVacancyLists from '../../components/List/Vacancy/InActiveVacancyLists';
import DeleteVacancyLists from '../../components/List/Vacancy/DeleteVacancyLists';
import VacancyFilter from '../../components/Filter/VacancyFilter';
import { Link, useLocation } from 'react-router-dom';
import { getStats } from '../../redux/actions/dashborad/getStats';
import Skeleton from 'react-loading-skeleton';

import { useDispatch, useSelector } from 'react-redux';
import { useFieldArray, useForm } from 'react-hook-form';
import { getVacancyList } from '../../redux/actions/dashborad/getVacancyList';
import VacancyEmpty from '../../components/List/Vacancy/VacancyEmpty';
import Loading from '../../components/Loading/Loading';
import { resetApproveModerationVacancy, resetDeleteVacancyList, resetDisableVacancyList, resetGetStats, resetGetVacancyList, resetRemoveVacancy } from '../../redux/slices/dashboard.slice';
import VacancyList from '../../components/List/Vacancy/VacancyList';
import { format } from 'date-fns';
import { deleteVacancyList } from '../../redux/actions/dashborad/deleteVacancyList';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getTariff } from '../../utils/getTariff';
import { removeVacancy } from '../../redux/actions/dashborad/removeVacancy';
import { disableVacancyList } from '../../redux/actions/dashborad/disableVacancyList';
import { approveModerationVacancy } from '../../redux/actions/dashborad/approveModerationVacancy';
import { usePermissions } from '../../hooks/usePermissions';
import { VACANCY_ACTION_PERMISSIONS } from '../../constants/vacancyActionPermissions';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}
function VacancyTable({ employerId, isAll, form, filter }) {
  const { pathname } = useLocation();
  const is_hr = pathname == '/jobs';
  const { hasPermission } = usePermissions();

  const dispatch = useDispatch();
  const page = useRef(1);
  const {
    getStats: { data: getStatsData, error: getStatsError, loading: getStatsLoading },
  } = useSelector((state) => state.dashboard);
  const {
    deleteVacancyList: { data: deleteVacancyListData, error: deleteVacancyListError, loading: deleteVacancyListLoading },
    removeVacancy: { data: removeVacancyData, error: removeVacancyError, loading: removeVacancyLoading },
    disableVacancyList: { data: disableVacancyListData, error: disableVacancyListError, loading: disableVacancyListLoading },
    approveModerationVacancy: { data: approveModerationVacancyData, loading: approveModerationVacancyLoading },
  } = useSelector((state) => state.dashboard);

  const [sortType, setSortType] = useState('date');
  const [sortDirection, setSortDirection] = useState(true);
  const [sortDisplayName, setSortDisplayName] = useState('по дате');
  const canDelete = hasPermission(VACANCY_ACTION_PERMISSIONS.DELETE);
  const canHardDelete = hasPermission(VACANCY_ACTION_PERMISSIONS.HARD_DELETE);
  const canDeactivate = hasPermission(VACANCY_ACTION_PERMISSIONS.DEACTIVATE);
  const canApproveModeration = hasPermission(VACANCY_ACTION_PERMISSIONS.ACCEPT_MODERATION);

  useEffect(() => {
    dispatch(getStats({ ...(employerId && { employer_id: employerId }), ...(!isAll && { is_hr }) }));
    dispatch(getVacancyList({ ...filter[0].params, page: page.current, ...(employerId && { employer_id: employerId }) }));
    return () => {
      dispatch(resetGetVacancyList());
      dispatch(resetGetStats());
    };
  }, [employerId]);
  useEffect(() => {
    return () => {
      dispatch(resetGetVacancyList());
    };
  }, []);

  const sort = (e) => {
    if (e.target.name === sortType) {
      setSortDirection(!sortDirection);
    } else {
      setSortDirection(true);
    }

    if (e.target.name === 'date') {
      setSortType('date');
      setSortDisplayName('по дате');
    } else if (e.target.name === 'reg') {
      setSortType('reg');
      setSortDisplayName('по рег данным');
    } else if (e.target.name === 'pay') {
      setSortType('pay');
      setSortDisplayName('по статусу оплаты');
    } else {
      setSortType('manager');
      setSortDisplayName('по менеджер');
    }
  };

  const handleActionState = (state, tab) => {
    // setActionState(state);
    // if (tab) {
    //   setTabState(tab);
    //   localStorage.setItem('tabState', tab);
    // }
  };

  const tabState = form.watch('tabState');
  const isShowAction = form.watch('isShowAction');
  const tabBulkActions = useMemo(
    () => ({
      active: {
        canDelete,
        canDeactivate,
      },
      moderation: {
        canApprove: canApproveModeration,
        canDelete,
      },
      inactive: {
        canDelete,
      },
      deleted: {
        canRestore: canDelete,
        canHardDelete,
      },
    }),
    [canApproveModeration, canDelete, canDeactivate, canHardDelete],
  );
  const currentTabActions = tabBulkActions?.[tabState?.value] || {};
  const hasBulkActionsForCurrentTab = Object.values(currentTabActions).some(Boolean);
  const [actionManyVacancy, setActionManyVacancy] = useState();
  const {
    getVacancyList: { data: getVacancyListData, error: getVacancyListError, loading: getVacancyListLoading },
  } = useSelector((state) => state.dashboard);
  React.useEffect(() => {
    const subscription = form.watch((value, { name, type }) => {
      if (name == 'vacancy') {
        const selectedVacancies = value?.vacancy || [];
        const isShowActionValue = hasBulkActionsForCurrentTab && !!selectedVacancies.filter((vac) => vac.checked)?.length;
        form.setValue('isShowAction', isShowActionValue);
      }
      console.log(name);

      if (name == 'tabState' || name == 'filter.type') {
        console.log(name);
        const filterType = value?.filter?.type;
        remove();
        page.current = 1;
        dispatch(getStats({ ...(filterType == 'vacancy' ? { is_hr: false } : filterType == 'hr' ? { is_hr: true } : {}) }));
        dispatch(getVacancyList({ ...value.tabState.params, page: page.current, ...(employerId && { employer_id: employerId }), ...(filterType == 'vacancy' ? { is_hr: false } : filterType == 'hr' ? { is_hr: true } : {}) }));
      }
    });
    return () => subscription.unsubscribe();
  }, [form.watch, hasBulkActionsForCurrentTab]);

  const { fields, append, update, remove } = useFieldArray({
    control: form?.control,
    name: 'vacancy',
    keyName: 'key',
  });

  useEffect(() => {
    if (hasBulkActionsForCurrentTab) {
      return;
    }

    let hasCheckedItems = false;
    fields.forEach((item, index) => {
      if (item.checked) {
        hasCheckedItems = true;
        update(index, { ...item, checked: false });
      }
    });

    if (hasCheckedItems || isShowAction) {
      form.setValue('isShowAction', false);
    }
  }, [fields, form, hasBulkActionsForCurrentTab, isShowAction, update]);

  useEffect(() => {
    if (getVacancyListData?.results?.length) {
      const data = getVacancyListData?.results?.map((item) => ({
        key: item.id,
        num: item.id,
        total_applications: item?.total_applications,
        date: format(item.created_at, 'dd.MM.yy'),
        state: 1,
        jobName: item.name,
        jobPosterName: item?.employer?.name || '-',
        regState: 1,
        type: getTariff(item.tariff),
        payState: item?.is_paid,
        manager: item.manager,
        is_verified: !item?.skip_verification && !item?.employer?.is_verified,
        vacState:
          item?.moderation?.status == 'reset_by_staff' && item?.created_by_staff
            ? 'created_by_staff'
            : item?.moderation?.status == 'reset_by_staff' && !item?.created_by_staff
            ? 'created_by_employer'
            : item?.moderation?.status == 'edited_by_employer' && item?.created_by_staff
            ? 'created_by_staff_edited_by_employer'
            : item?.moderation?.status,
        checked: false,
      }));

      append(data);
    }
  }, [getVacancyListData]);

  useEffect(() => {
    if (deleteVacancyListData) {
      toast.success(actionManyVacancy == 'recovery' ? 'Вакансии успешно восстановлены' : 'Вакансии успешно удалены', { theme: 'colored', autoClose: '3000' });
      remove();
      page.current = 1;
      dispatch(getVacancyList({ ...tabState.params, page: page.current, ...(employerId && { employer_id: employerId }) }));
      dispatch(getStats({ ...(!isAll && { is_hr }) }));
      setActionManyVacancy();
      dispatch(resetDeleteVacancyList());
    }
  }, [deleteVacancyListData]);
  useEffect(() => {
    if (removeVacancyData) {
      toast.success('Вакансии удалены успешно', { theme: 'colored', autoClose: '3000' });
      remove();
      page.current = 1;
      dispatch(getVacancyList({ ...tabState.params, page: page.current, ...(employerId && { employer_id: employerId }) }));
      dispatch(getStats({ ...(!isAll && { is_hr }) }));
      setActionManyVacancy();
      dispatch(resetRemoveVacancy());
    }
  }, [removeVacancyData]);

  useEffect(() => {
    if (disableVacancyListData) {
      toast.success('Вакансии успешно деактивированы', { theme: 'colored', autoClose: '3000' });
      remove();
      page.current = 1;
      dispatch(getVacancyList({ ...tabState.params, page: page.current, ...(employerId && { employer_id: employerId }) }));
      dispatch(getStats({ ...(!isAll && { is_hr }) }));
      setActionManyVacancy();
      dispatch(resetDisableVacancyList());
    }
  }, [disableVacancyListData]);
  useEffect(() => {
    if (approveModerationVacancyData) {
      toast.success('Вакансии отправлены на согласование', { theme: 'colored', autoClose: '3000' });
      remove();
      page.current = 1;
      dispatch(getVacancyList({ ...tabState.params, page: page.current, ...(employerId && { employer_id: employerId }) }));
      dispatch(getStats({ ...(!isAll && { is_hr }) }));
      setActionManyVacancy();
      dispatch(resetApproveModerationVacancy());
    }
  }, [approveModerationVacancyData]);

  return (
    <div className="flex w-full flex-col zero:w-[70%] p-2">
      <div className="flex justify-between items-center">
        <ul className="hidden md:flex list-none gap-x-3 border-b border-gray-200 justify-center items-baseline">
          {filter?.map((item) => (
            <li
              onClick={() => {
                form.setValue('tabState', item);
              }}
              className={`cursor-pointer hover:text-[#00B2A4] pb-1 ${tabState.value === item.value ? 'font-bold text-[#00B2A4]' : 'border-b-1 border-[#00B2A4] border-dotted '}`}
              id="active">
              {item?.label}
              {<> {getStatsLoading ? <Skeleton width={'20.6px'} height={'20.6px'} className="translate-y-[-2px]" /> : <>({getStatsData?.[item?.value]})</>}</>}
            </li>
          ))}
        </ul>
        <div className="flex md:hidden ">
          <Menu as="div" className="relative inline-block text-left z-[1000]">
            <div>
              <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                {tabState?.label}
                {getStatsLoading ? <Skeleton width={'17.4px'} height={'18px'} className="translate-y-[-2px]" /> : <span>({getStatsData?.[tabState?.value]})</span>}
                <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
              </Menu.Button>
            </div>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95 relative z-[1000]">
              <Menu.Items className="absolute left-0 z-10 mt-2 w-56 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div className="py-1">
                  {filter?.map((item) => (
                    <Menu.Item>
                      {({ active }) => (
                        <Link
                          onClick={() => {
                            form.setValue('tabState', item);
                          }}
                          className={classNames(tabState.value == item.value ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                          {item?.label} {getStatsLoading ? <Skeleton width={'18.4px'} height={'17.2px'} className="translate-y-[-2px]" /> : <>({getStatsData?.[item?.value]})</>}
                        </Link>
                      )}
                    </Menu.Item>
                  ))}
                </div>
              </Menu.Items>
            </Transition>
          </Menu>
        </div>
        {/* <div className="hs-dropdown relative inline-flex [--strategy:absolute]">
          <button id="hs-dropdown-right-but-left-on-lg-custom" type="button" className="hs-dropdown-toggle flex items-center gap-x-2 text-center border rounded py-2 px-4 bg-button text-white hover:bg-button-hov w-fit transition ease-in-out duration-300">
            {sortDisplayName}
            {sortDirection ? <AscendingSvg color="#ffffff" /> : <DescendingSvg color="#ffffff" />}
          </button>

          <div className="hs-dropdown-menu w-60 transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden z-10 top-0 end-0 start-auto min-w-[10rem] bg-white shadow-md rounded-lg p-2 mt-2 " aria-labelledby="hs-dropdown-right-but-left-on-lg-custom">
            <Link onClick={sort} name="date" className="flex flex-row justify-between items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100">
              по дате
              {sortType === 'date' ? sortDirection ? <AscendingSvg color="#000000" /> : <DescendingSvg color="#000000" /> : ''}
            </Link>
            <Link onClick={sort} name="reg" className="flex flex-row justify-between items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100">
              по рег данным
              {sortType === 'reg' ? sortDirection ? <AscendingSvg color="#000000" /> : <DescendingSvg color="#000000" /> : ''}
            </Link>
            <Link onClick={sort} name="pay" className="flex flex-row justify-between items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100">
              по статусу оплаты
              {sortType === 'pay' ? sortDirection ? <AscendingSvg color="#000000" /> : <DescendingSvg color="#000000" /> : ''}
            </Link>
            <Link onClick={sort} name="manager" className="flex flex-row justify-between items-center gap-x-3.5 py-2 px-3 rounded-lg text-sm text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100">
              по менеджер
              {sortType === 'manager' ? sortDirection ? <AscendingSvg color="#000000" /> : <DescendingSvg color="#000000" /> : ''}
            </Link>
          </div>
        </div> */}
      </div>

      {isShowAction && hasBulkActionsForCurrentTab ? (
        <div className="flex justify-end mt-4 z-[1001]">
          {' '}
          {(deleteVacancyListLoading || approveModerationVacancyLoading) && (
            <div className="relative h-[36.4px] w-[36.4px] mr-2 scale-90">
              <Loading />
            </div>
          )}
          {tabState.value === 'active' ? (
            <Menu as="div" className="relative inline-block text-left z-[1000]">
              <div>
                <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                  Действия
                  <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                </Menu.Button>
              </div>

              <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
                <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="py-1">
                    {currentTabActions.canDeactivate && (
                      <Menu.Item>
                        {({ active }) => (
                          <div
                            onClick={() => {
                              dispatch(disableVacancyList(fields?.filter((item) => item.checked).map((item) => item.num)));
                            }}
                            className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm select-none cursor-pointer')}>
                            Деактивировать
                          </div>
                        )}
                      </Menu.Item>
                    )}
                    {currentTabActions.canDelete && (
                      <Menu.Item>
                        {({ active }) => (
                          <div
                            onClick={() => {
                              Swal.fire({
                                title: 'Вы действительно хотите удалить выбранные вакансии ?',
                                text: '',
                                icon: 'error',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Да',
                                cancelButtonText: 'Нет',
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  dispatch(
                                    deleteVacancyList({
                                      is_active: false,
                                      vacancies: fields?.filter((item) => item.checked).map((item) => item.num),
                                    }),
                                  );
                                }
                              });
                            }}
                            className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm select-none cursor-pointer')}>
                            Удалить
                          </div>
                        )}
                      </Menu.Item>
                    )}
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
          ) : tabState.value === 'moderation' ? (
            <Menu as="div" className="relative inline-block text-left z-[1000]">
              <div>
                <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                  Действия
                  <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                </Menu.Button>
              </div>

              <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
                <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="py-1">
                    {currentTabActions.canApprove && (
                      <Menu.Item>
                        {({ active }) => (
                          <div
                            onClick={() => {
                              dispatch(approveModerationVacancy(fields?.filter((item) => item.checked).map((item) => item.num)));
                            }}
                            className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm select-none cursor-pointer')}>
                            Согласовать
                          </div>
                        )}
                      </Menu.Item>
                    )}
                    {currentTabActions.canDelete && (
                      <Menu.Item>
                        {({ active }) => (
                          <div
                            onClick={() => {
                              Swal.fire({
                                title: 'Вы действительно хотите удалить выбранные вакансии ?',
                                text: '',
                                icon: 'error',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Да',
                                cancelButtonText: 'Нет',
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  dispatch(
                                    deleteVacancyList({
                                      is_active: false,
                                      vacancies: fields?.filter((item) => item.checked).map((item) => item.num),
                                    }),
                                  );
                                }
                              });
                            }}
                            className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm  select-none cursor-pointer')}>
                            Удалить
                          </div>
                        )}
                      </Menu.Item>
                    )}
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
          ) : tabState.value === 'inactive' ? (
            <div
              onClick={() => {
                Swal.fire({
                  title: 'Вы действительно хотите удалить выбранные вакансии ?',
                  text: '',
                  icon: 'error',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: 'Да',
                  cancelButtonText: 'Нет',
                }).then((result) => {
                  if (result.isConfirmed) {
                    dispatch(
                      deleteVacancyList({
                        is_active: false,
                        vacancies: fields?.filter((item) => item.checked).map((item) => item.num),
                      }),
                    );
                  }
                });
              }}
              className={'inline-flex w-fit justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 cursor-pointer select-none'}>
              Удалить
            </div>
          ) : (
            <Menu as="div" className="relative inline-block text-left z-[1000]">
              <div>
                <Menu.Button className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                  Действия
                  <ChevronDownIcon className="-mr-1 h-5 w-5 text-gray-400" aria-hidden="true" />
                </Menu.Button>
              </div>

              <Transition as={Fragment} enter="transition ease-out duration-100" enterFrom="transform opacity-0 scale-95" enterTo="transform opacity-100 scale-100" leave="transition ease-in duration-75" leaveFrom="transform opacity-100 scale-100" leaveTo="transform opacity-0 scale-95">
                <Menu.Items className="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                  <div className="py-1">
                    {currentTabActions.canRestore && (
                      <Menu.Item>
                        {({ active }) => (
                          <div
                            onClick={() => {
                              Swal.fire({
                                title: 'Вы действительно хотите восстановить выбранные вакансии ?',
                                text: '',

                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Да',
                                cancelButtonText: 'Нет',
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  dispatch(
                                    deleteVacancyList({
                                      is_active: true,
                                      vacancies: fields?.filter((item) => item.checked).map((item) => item.num),
                                    }),
                                  );
                                  setActionManyVacancy('recovery');
                                }
                              });
                            }}
                            className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm select-none cursor-pointer')}>
                            Восстановить
                          </div>
                        )}
                      </Menu.Item>
                    )}
                    {currentTabActions.canHardDelete && (
                      <Menu.Item>
                        {({ active }) => (
                          <Link
                            onClick={() => {
                              Swal.fire({
                                title: 'Вы действительно хотите удалить безвозвратно выбранные вакансии ?',
                                text: '',
                                showCancelButton: true,
                                confirmButtonColor: '#3085d6',
                                cancelButtonColor: '#d33',
                                confirmButtonText: 'Да',
                                cancelButtonText: 'Нет',
                              }).then((result) => {
                                if (result.isConfirmed) {
                                  dispatch(removeVacancy(fields?.filter((item) => item.checked).map((item) => item.num)));
                                }
                              });
                            }}
                            className={classNames(active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'block px-4 py-2 text-sm')}>
                            Удалить безвозвратно
                          </Link>
                        )}
                      </Menu.Item>
                    )}
                  </div>
                </Menu.Items>
              </Transition>
            </Menu>
          )}
        </div>
      ) : (
        <></>
      )}

      {/* tab content */}
      <div className="mt-3">
        {!fields?.length ? (
          <VacancyEmpty>{tabState.emptyText}</VacancyEmpty>
        ) : (
          <>
            <VacancyList
              onLoadMore={() => {
                if (getVacancyListData?.next) {
                  page.current += 1;

                  dispatch(getVacancyList({ ...tabState.params, page: page.current, ...(employerId && { employer_id: employerId }) }));
                }
              }}
              fields={fields}
              update={update}
              form={form}
              filter={tabState}
              showCheckboxes={hasBulkActionsForCurrentTab}
            />
            {/* {tabState.value === 'active' ? (
                  <ActiveVacancyLists sortType={sortType} sortDirection={sortDirection} actionState={handleActionState} />
                ) : tabState.value === 'moderation' ? (
                  <ModerationVacancyLists sortType={sortType} sortDirection={sortDirection} actionState={handleActionState} form={form} />
                ) : tabState.value === 'inactive' ? (
                  <InActiveVacancyLists sortType={sortType} sortDirection={sortDirection} actionState={handleActionState} />
                ) : (
                  <DeleteVacancyLists sortType={sortType} sortDirection={sortDirection} actionState={handleActionState} />
                )} */}
          </>
        )}
      </div>
    </div>
  );
}
export default VacancyTable;
